<script setup lang="ts">
import {
  ConstantFactory,
  EnrollmentFactory,
  StartWorkflowFactory,
  TrackerFactory,
  WorkspaceFactory
} from "@/common/services/services.module";
import type IWorkspaceStore from "@/common/services/Workspace/IWorkspaceStore";
import { $inj, $injByInterface } from "@/common/decorators/depinject";
import { WorkflowStatesConstant } from "@/common/constant/WorkflowStatesConstant";
import { ErrorHandler } from "@/open/handlers/ErrorHandler";
import WORKFLOW_TYPES from "@/common/enums/workflowTypesEnum";
import { WorkflowCodesConstant } from "@/common/constant/WorkflowCodesConstant";
import { AddressConstant } from "@/common/constant/AddressConstant";
import { onErrorCaptured } from "vue";
import type IRouterService from "@/common/services/utils/IRouterService";
import WorkspacePromoCodeService from "@/common/services/Workspace/WorkspacePromoCodeService";
import { QueryPropertiesService } from "@/open/app/factories/config/queryProperties.service";
import { QueryPropertyKey } from "@/open/app/factories/config/queryProperties.enum";
import WorkspaceReferralService from "@/common/services/Workspace/WorkspaceReferralService";
import QueryParameterCollectionService
  from "@/common/services/QueryParameterCollectionService/QueryParameterCollectionService";

const routerService = $injByInterface<IRouterService>("IRouterService");
const workspaceStore = $injByInterface<IWorkspaceStore>("IWorkspaceStore");
const workspaceFactory = $inj(WorkspaceFactory);
const startWorkflowFactory = $inj(StartWorkflowFactory);
const enrollmentFactory = $inj(EnrollmentFactory);
const constantFactory = $inj(ConstantFactory);
const trackerFactory = $inj(TrackerFactory);
const queryParameterCollectionService = $inj(QueryParameterCollectionService)

await Promise.all([
  // making workspace api call below
  workspaceFactory.postWorkspace({ workspaceType: WORKFLOW_TYPES.PERSON }).then((workspace) => {
    // storing workspace response and workspace id below

    queryParameterCollectionService.saveAllForWorkspace(workspace.workspaceUUID)

    workspaceStore.workspaceUUID = workspace.workspaceUUID;
    return workspace;
  }),
  // making start person startworkflow api call below
  startWorkflowFactory.get(WorkflowCodesConstant.START_PERSON)
]).then(async (response) => {
  const workspace = response[0];
  const startWorkflow = response[1];
  // making enrollment api call below
  const enrolmentData = await enrollmentFactory.post(
    workspace.workspaceUUID,
    null,
    constantFactory.getProp(AddressConstant.OPEN_BRANCH_LOCATION),
    response[1].intention
  );
  workspaceStore.enrollment.enrollmentId = Array.isArray(enrolmentData)
    ? enrolmentData[0].enrollmentId
    : enrolmentData.payload[0].enrollmentId;

  // fetching tracker id
  const trackerDetails = await trackerFactory.init(
    workspace.workspaceUUID,
    null,
    Array.isArray(enrolmentData) ? enrolmentData[0].enrollmentId : enrolmentData.payload[0].enrollmentId,
    startWorkflow.workflowName,
    startWorkflow.startStateId
  );

  // storing tracker id
  workspaceStore.trackerUUID = trackerDetails.trackerUUID;
});
// redirect to workflow
routerService.push({
  name: WorkflowStatesConstant.WORKFLOW.STATE,
  params: { workspaceUUID: workspaceStore.workspaceUUID },
  query: { trackerUUID: workspaceStore.trackerUUID },
  replace: true
});

onErrorCaptured((err, _vm, _info) => {
  ErrorHandler.handle(err);
});

defineExpose({
  trackerFactory
});
</script>
<template>
  <div></div>
</template>
